import { useDispatch } from "react-redux"
import { classNames } from "primereact/utils";
import { useAppSelector } from "../../../../../../stateManagement/hooks/redux";
import { convertDate } from "../../../../../../features/dataFormatFunctions/dataFormatter";
import { setTransportHistoryChosenDate, setTransportHistoryCurrentTransportDates, setTransportHistoryCurrentTransportDriveways, setTransportHistoryCurrentTransportId } from "../../../../../../stateManagement/reducers/transport/TransportHistorySlice";

export default function TransportListItem({ id, garageNumber, carBrand, company }: any) {

    const dispatch = useDispatch();
    const transportHistoryCurrentTransportId = useAppSelector(state => state.transportHistory.transportHistoryCurrentTransportId)
    const transportHistoryDrivewaysList = useAppSelector(state => state.transportHistory.transportHistoryDrivewaysList)
    function clickDrivewaysListItem() {
        dispatch(setTransportHistoryCurrentTransportId(id))
        let transport = transportHistoryDrivewaysList.find((item: any) => item.id == id)
        let datesForSort = [...transport?.dates]
        let sortedDates = datesForSort.sort(function (a: any, b: any) {
            a = new Date(a)
            b = new Date(b)
            return a - b;
        });
        dispatch(setTransportHistoryChosenDate(convertDate(sortedDates[0])))
        dispatch(setTransportHistoryCurrentTransportDriveways(transport?.driveways))
        let datesObjects = datesForSort.map((date: any) => {
            let dateWithoutTime = date.split(' ')[0];
            let splitDateWithoutTime = dateWithoutTime.split('-')
            let day = splitDateWithoutTime[2].replace(/^0+/, '')
            let month = splitDateWithoutTime[1].replace(/^0+/, '')
            let year = splitDateWithoutTime[0].replace(/^0+/, '')
            return { day, month, year }
        })
        dispatch(setTransportHistoryCurrentTransportDates(datesObjects))
    }

    let transportListItemClassName = classNames({
        "transport-list-item": true,
        "active": transportHistoryCurrentTransportId === id
    })

    return (
        <div className={transportListItemClassName} onClick={clickDrivewaysListItem}>
            <span className="garageNumber">{garageNumber}</span>
            <span className="carBrand">{carBrand}</span>
            <span className="company">{company}</span>
        </div>
    )
}
